var prefix = '/v2';
module.exports = {
  prefix: '/v2',

  get authorize() {
    return {
      url: "".concat(prefix, "/authorize")
    };
  },

  boards: {
    get create() {
      return {
        url: "".concat(prefix, "/boards")
      };
    },

    find: function find(boardId) {
      return {
        url: "".concat(prefix, "/boards/").concat(boardId),
        method: 'get'
      };
    },
    addFiles: function addFiles(board) {
      return {
        url: "".concat(prefix, "/boards/").concat(board.id, "/files")
      };
    },
    addLinks: function addLinks(board) {
      return {
        url: "".concat(prefix, "/boards/").concat(board.id, "/links")
      };
    },
    multipart: function multipart(board, file, partNumber) {
      return {
        url: "".concat(prefix, "/boards/").concat(board.id, "/files/").concat(file.id, "/upload-url/").concat(partNumber, "/").concat(file.multipart.id),
        method: 'get'
      };
    },
    upload: function upload(uploadUrl) {
      return {
        url: uploadUrl
      };
    },
    uploadComplete: function uploadComplete(board, file) {
      return {
        url: "".concat(prefix, "/boards/").concat(board.id, "/files/").concat(file.id, "/upload-complete"),
        method: 'put'
      };
    }
  },
  transfers: {
    get create() {
      return {
        url: "".concat(prefix, "/transfers")
      };
    },

    find: function find(transferId) {
      return {
        url: "".concat(prefix, "/transfers/").concat(transferId),
        method: 'get'
      };
    },
    multipart: function multipart(transfer, file, partNumber) {
      return {
        url: "".concat(prefix, "/transfers/").concat(transfer.id, "/files/").concat(file.id, "/upload-url/").concat(partNumber),
        method: 'get'
      };
    },
    upload: function upload(uploadUrl) {
      return {
        url: uploadUrl
      };
    },
    uploadComplete: function uploadComplete(transfer, file) {
      return {
        url: "".concat(prefix, "/transfers/").concat(transfer.id, "/files/").concat(file.id, "/upload-complete"),
        method: 'put'
      };
    },
    finalize: function finalize(transfer) {
      return {
        url: "".concat(prefix, "/transfers/").concat(transfer.id, "/finalize"),
        method: 'put'
      };
    }
  }
};